<template>
  <div v-if="isInitPermission" id="content" class="transfer">
    <aaa></aaa>
    <div style="display: none">
      <uploader :options="uploadOptions" ref="uploader" class="uploader-example" :directory="directory"
                @upload-start="uploadfileStart(file)" :file="file" @file-progress="fileProgress"
                @file-success="fileSuccess" @file-error="fileError" @file-added="fileAdded"
                @file-complete="fileComplete">
        <uploader-btn :attrs="attrs"></uploader-btn>
      </uploader>
    </div>
    <transition name="slide-fade">
      <router-view class="content"></router-view>
    </transition>
  </div>
</template>
<script>
  import apis from '../../apis/index'
  import $ from 'jquery'
  import {Toast} from 'mint-ui'
  import {sliceName} from '../../assets/js/tools'
  import {eventBus} from '../../utils/event-bus'
  import aaa from '@/components/backAndClose.vue'

  export default {
    name: 'index',
    components: {
      Toast,
      sliceName,
      aaa
    },
    data () {
      return {
        file: '',
        isShows: false,
        attrs: {
          accept: '*'
        },
        directory: false,
        uploadOptions: {
          testChunks: false,
          uploadMethod: 'POST',
          target: apis.app.cloudStorage.baseUrl + '/api/file/simpleUpload',
          testMethod: 'POST',
          preprocess: this.preprocess,
          withCredentials: true,
          chunkSize: 10485760,
          forceChunkSize: true,
          query: this.queryFun,
          allowDuplicateUploads: true,
          headers: {
            'CS-PLATFORM': 'mobile'
          }
        },
        listShow: false,
        btnShow: false,
        uploader: '',
        fileList: {
          success: [],
          error: [],
          wait: []
        },
        delShow: '',
        isInitPermission: false
      }
    },
    mounted () {
      this.$store.dispatch('getPermissionBtns').then(() => {
        this.isInitPermission = true
        this.$nextTick(() => {
          $('.uploader-drop').hide()
          $('.uploader-list').hide()
          this.uploader = this.$refs.uploader.uploader
        })
      })
    },
    updated: function () {
      this.$nextTick(function () {
        // 读取当前url 判断是否显示列表
        if (window.location.hash === '#/transfer') {
          this.listShow = true
        } else {
          this.listShow = false
          $('.uploader-list').hide()
        }
        // 读取当前是否有上传的操作 来显示上传按钮
        if (window.location.hash === '#/index' || window.location.hash === '#/shareFile') {
          this.btnShow = true
        } else {
          this.btnShow = false
          $('.uploader-drop').hide()
        }
      })
    },
    methods: {
      // 文件上传前判断是否携带分片信息
      preprocess: function (e) {
        let file = e.file
        let chunk = {}
        const progress = (e.startByte / file.size).toFixed(2)
        this.$store.commit('uploading', {id: file.id, progress})
        if (parseInt(file.size) > parseInt(10485760)) {
          chunk.chunk = e.offset
          chunk.chunks = file.chunks.length
          // this.queryFun(e.file, chunk, true)
        }
        e.preprocessFinished()
      },
      // 参数上传配置
      queryFun: function (file, chunk, type) {
        if (!file.guid) {
          file.guid = file.uniqueIdentifier + new Date().getTime()
        }
        let query =
          {
            guid: file.guid,
            dirId: this.$store.state.fileId,
            size: file.size,
            type: file.fileType,
            name: file.name,
            lastModifiedDate: file.file.lastModifiedDate
          }
        if (parseInt(chunk.file.size) > parseInt(10485760)) {
          query.chunk = chunk.offset
          query.chunks = chunk.file.chunks.length
        }
        return query
      },
      // 文件加入队列
      fileAdded: function (file, event) {
        // this.fileList.wait.push(file)
        let usedSize = JSON.parse(window.sessionStorage.mobileData).usedSize
        let quota = JSON.parse(window.sessionStorage.mobileData).quota

        if (file.size <= quota - usedSize) {
          this.$store.commit('fileListPush', {type: 0, file: file})
        } else {
          file.ignored = true
          Toast({
            message: '空间不足,请申请或清空回收站',
            iconClass: 'icon-error'
          })
          this.isShows = true
        }
      },
      // 文件开始上传
      uploadfileStart: function (index) {
        if (!this.isShows) {
          Toast({
            message: '文件已添加至上传列表...',
            iconClass: 'icon-success'
          })
        }
        this.isShows = false
        this.$router.push('/transfer')
      },
      // 文件上传失败
      fileError: function (rootFile, file, message, chunk) {
        // Toast({
        //   message: JSON.parse(message).message,
        //   iconClass: 'icon-error'
        // })
        file.newDate = new Date()
        file.message = JSON.parse(message).message
        this.$store.commit('fileListRemove', {type: 0, file: file})
        this.$store.commit('fileListPush', {type: 2, file: file})
      },
      // 文件上传成功
      fileSuccess: function (rootFile, file, message, chunk) {
        file.newDate = new Date()
        this.$store.commit('fileListRemove', {type: 0, file: file})
        this.$store.commit('fileListPush', {type: 1, file: file})
      },
      // 文件上传结束
      fileProgress: function (rootFile, file, chunk) {
//        this.$store.commit('fileListRemove', {type: 0, file: file})
      },
      // 文件上传完成
      fileComplete: function (rootFile) {
        Toast({
          message: '上传成功',
          iconClass: 'icon-success'
        })
        eventBus.$emit('initShareData')
        eventBus.$emit('initFileData')
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  /*@import 'styles/index';*/
  #content {
    height: 100%;
    background: #F7F7FA;
  }

</style>



// WEBPACK FOOTER //
// src/views/layout/MainLayout.vue